import React from "react";

/**
 * Fallback UI for Sentry ErrorBoundary.
 * Uses a plain <button> (not design system) to avoid cascading errors
 * if the design system itself caused the crash.
 */
const SentryFallback = () => (
    <div
        style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            padding: 40,
            fontFamily:
                "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            backgroundColor: "#fafafa",
        }}
    >
        <h2 style={{ color: "#1B1B1B", marginBottom: 12 }}>
            Something went wrong
        </h2>
        <p style={{ color: "#666", fontSize: 16, marginBottom: 24 }}>
            An unexpected error occurred. Please reload the page.
        </p>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", justifyContent: "center" }}>
            <button
                onClick={() => window.location.reload()}
                style={{
                    backgroundColor: "#FED230",
                    color: "#1B1B1B",
                    border: "none",
                    padding: "10px 24px",
                    fontSize: 14,
                    fontWeight: 600,
                    borderRadius: 4,
                    cursor: "pointer",
                }}
            >
                Reload Page
            </button>
            <a
                href="/reset.html"
                style={{
                    color: "#1B1B1B",
                    padding: "10px 12px",
                    fontSize: 14,
                    fontWeight: 600,
                    textDecoration: "underline",
                }}
            >
                Reset HRP Session
            </a>
        </div>
    </div>
);

export default SentryFallback;
